import { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import useSeti from '@/hooks/useSeti'

const useMobilePromobarsExperiment = () => {
  const { isMobile = false } = useContext(BootstrapDataContext)

  const isMobilePromoSETI =
    useSeti('HP_LP_MBL_PROMOBARS', isMobile) === 'VARIANT'

  return isMobilePromoSETI
}

export default useMobilePromobarsExperiment
